import React, { useMemo } from 'react';
import { ScrapbookFile } from '@/api';
import { ScrapbookContentType } from '@/types/ScrapbookModel';

interface FilterOption {
  id: number;
  name: string;
  contentType: string;
  count: number;
}

interface FilterTabsProps {
  files: ScrapbookFile[];
  selectedFilter: number;
  onFilterChange: (filterId: number) => void;
}

const FilterTabs: React.FC<FilterTabsProps> = ({ files, selectedFilter, onFilterChange }) => {
  const filters: FilterOption[] = useMemo(() => {
    const filterOptions = [
      { id: 0, name: 'All', contentType: '', count: 0 },
      { id: 1, name: 'Reports', contentType: ScrapbookContentType.Article, count: 0 },
      { id: 2, name: 'Images', contentType: ScrapbookContentType.Image, count: 0 },
      { id: 3, name: 'Quote', contentType: ScrapbookContentType.Quote, count: 0 },
      { id: 4, name: 'Stats', contentType: ScrapbookContentType.Stat, count: 0 },
      { id: 5, name: 'Highlights', contentType: ScrapbookContentType.ArticleExtract, count: 0 },
      { id: 6, name: 'Colour', contentType: ScrapbookContentType.Colour, count: 0 },
      { id: 7, name: 'Colour Palette', contentType: ScrapbookContentType.ColourPalette, count: 0 },
      { id: 8, name: 'My files', contentType: ScrapbookContentType.Blob, count: 0 },
      { id: 9, name: 'Stylus AI', contentType: ScrapbookContentType.AIChat, count: 0 },
      { id: 10, name: 'Stylus AI Summary', contentType: ScrapbookContentType.AISummary, count: 0 },
      { id: 11, name: 'Tech Launches Database', contentType: ScrapbookContentType.TechLaunchDatabase, count: 0 },
      { id: 12, name: 'Analytics Builder', contentType: ScrapbookContentType.AnalyticsBuilder, count: 0 },
    ];

    // Count files for each filter
    files.forEach((file) => {
      filterOptions[0].count++; // All

      if (file.isBlob) {
        const blobFilter = filterOptions.find((f) => f.contentType === 'blob');
        if (blobFilter) blobFilter.count++;
      } else {
        const matchingFilter = filterOptions.find((f) => f.contentType === file.contentType);
        if (matchingFilter) matchingFilter.count++;
      }
    });

    return filterOptions;
  }, [files]);

  return (
    <div className="flex items-center gap-2 text-sm">
      {filters.map(
        (filter) =>
          filter.count > 0 && (
            <button
              key={filter.id}
              onClick={() => onFilterChange(filter.id)}
              className={`cursor-pointer ${
                filter.id === selectedFilter ? 'font-bold text-gray-900' : 'text-gray-600 hover:text-gray-900'
              }`}
            >
              {filter.name} ({filter.count})
            </button>
          ),
      )}
    </div>
  );
};

export default FilterTabs;
